import { SelectOption } from '@/components/form-builder/form-builder.types';
import { createStore, withProps } from '@ngneat/elf';

export interface CompanyBlacklistStateProps {
  response?: any;
  dto?: any;
  selectedCompany?: SelectOption;
  selectedCompanyObject?: any;
}

export const companyBlacklistStateInitialState: CompanyBlacklistStateProps = {
  response: {},
  dto: {},
  selectedCompany: { name: '', code: 0 },
  selectedCompanyObject: null,
};

export const companyBlacklistStateStore = createStore(
  { name: 'company-blacklist-state' },
  withProps<CompanyBlacklistStateProps>(companyBlacklistStateInitialState)
);
